exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table[data-v-006701cf] {\n  width: 100%;\n  border-collapse: collapse;\n}\ntable th[data-v-006701cf],\ntable td[data-v-006701cf] {\n  border: 1px solid black;\n  padding: 8px;\n  text-align: center;\n}\n", ""]);

// exports
